import {Button, Tooltip} from 'antd';
import React, {FC} from 'react';

import {useBreadcrumbsController} from 'components/table-report/hooks/use-breadcrumbs-controller';
import {IControlRatiosCustomValue} from 'features/calculate-control-ratios/model/types';
import {ELocationStateKey, useAppHistory} from 'shared/hooks/use-app-history';

import s from './columns.module.less';

interface IControlRatiosDDColumnProps {
    cellValue: IControlRatiosCustomValue | null;
    docId: string | null;
}

export const ControlRatiosDDColumn: FC<IControlRatiosDDColumnProps> = (
    {cellValue, docId}: IControlRatiosDDColumnProps,
) => {
    const {
        childDocId,
        templateCode,
        isCorrect,
        value,
        parentControlRatioId,
        tooltip,
        analytics = null,
    } = cellValue ?? {};

    const {pushWithStateUpdate} = useAppHistory();
    const {getNextStepBreadcrumbs} = useBreadcrumbsController({
        docId: childDocId,
        templateCode,
    });

    if (!cellValue) return null;

    const reportLink = `/table-reports/${childDocId}/${templateCode}`;

    const handleLinkClick = () => {
        const newBreadcrumbs = getNextStepBreadcrumbs({
            name: tooltip ?? '',
            path: reportLink,
        });

        if (!newBreadcrumbs) {
            console.error('Ошибка при генерации хлебных крошек для перехода');
            return;
        }

        pushWithStateUpdate(reportLink, {
            [ELocationStateKey.TABLE_REPORT_BREADCRUMBS]: newBreadcrumbs,
            [ELocationStateKey.TABLE_REPORT_CUSTOM_CR_PARAMS]: {
                CONTROL_RATIO_ID: parentControlRatioId,
                PARENT_DOC_ID_CR: docId,
                ANALYTICS: analytics,
            },
            // обнуляем параметры отчета, из которого уходим, чтобы они не передались при переходе
            [ELocationStateKey.TABLE_REPORT_LOCATION_DEFAULTS]: undefined,
        });
    };

    return (
        <Tooltip
            title={tooltip}
            mouseEnterDelay={0.5}
        >
            <Button
                type="link"
                role="link"
                onClick={handleLinkClick}
            >
                <span className={s[`text-${isCorrect ? 'positive' : 'negative'}`]}>
                    {value}
                </span>
            </Button>
        </Tooltip>
    );
};
